import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import interceptorsSetup from './helpers/interceptors'
import '@/assets/css/_htmlContent.styl'
import '@/components/index'

Vue.config.productionTip = false
//
import './helpers/ruleValidate'
import './plugins/buddhisYear'
import './helpers/dayjs'
import './plugins/filters'
import './plugins/toast'
import i18n from './plugins/i18n'

interceptorsSetup()

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
